export default __webpack_public_path__ + "static/media/mappr_logo_300.50003e39.png";